export const listPlayersWithTraits = /* GraphQL */ `
  query ListPlayersWithTraits($limit: Int, $nextToken: String, $filter: ModelPlayerFilterInput) {
    listPlayers(limit: $limit, nextToken: $nextToken, filter: $filter) {
      items {
        id
        name
        dateOfBirth
        town
        state
        teamId
        pitcher
        catcher
        battingHandedness
        throwingHandedness
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
